// src/context/ThemeContextAPI.jsx
import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";
import THEMES_ADMIN_API  from "../data/api";
const ThemeContextAPI = createContext();

export const ThemeProviderAPI = ({ children }) => {
  const [theme, setTheme] = useState("from-blue-50 via-white to-blue-100");
  const [loading, setLoading] = useState(true);

  // Fetch theme from API
  const fetchTheme = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${THEMES_ADMIN_API.GET_THEMES}/Theme`);
      setTheme(res.data.themeValue);
    } catch (err) {
      console.error("Error fetching theme:", err);
    } finally {
      setLoading(false);
    }
  };

  // Update theme (called by admin)
  const updateTheme = async (newThemeValue) => {
    try {
      const res = await axios.put("https://localhost:44370/api/Theme", {
        themeId: 1,
        themeName: "adminUpdated",
        themeValue: newThemeValue,
      });
      setTheme(res.data.themeValue);
    } catch (err) {
      console.error("Error updating theme:", err);
    }
  };

  useEffect(() => {
    fetchTheme();
  }, []);

  return (
    <ThemeContextAPI.Provider value={{ theme, updateTheme, loading }}>
      {children}
    </ThemeContextAPI.Provider>
  );
};

export const useThemeAPI = () => useContext(ThemeContextAPI);
